/* Solace Bodywork — theme behaviour.
   Vanilla, no dependencies. Everything degrades to a working page without JS. */
(function () {
  'use strict';

  /* ---------- Mobile navigation ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.getElementById('MobileNav');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.getAttribute('data-open') === 'true';
      mobileNav.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.getAttribute('data-open') === 'true') {
        mobileNav.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10);
      input.value = Math.max(parseInt(input.min || '1', 10), next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Product gallery ---------- */
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelector('[data-thumbs]');

  if (mainImage && thumbs) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-full]');
      if (!btn) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = btn.dataset.full;
      thumbs.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-current', String(b === btn));
      });
    });
  }

  /* ---------- Variant selection ---------- */
  var root = document.querySelector('[data-product-root]');
  var variantJson = root && root.querySelector('[data-variant-json]');

  if (root && variantJson) {
    var variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (err) {
      variants = null;
    }

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add-button]');
    var addText = root.querySelector('[data-add-text]');

    var money = function (cents) {
      // Store currency is AUD; Shopify's money format is applied server-side on
      // first render, so mirror the common "$0.00" shape on client updates.
      return '$' + (cents / 100).toFixed(2);
    };

    var update = function () {
      if (!variants) return;
      var chosen = selects.map(function (s) { return s.value; });

      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });

      if (!match) return;

      if (idField) idField.value = match.id;

      if (priceEl) {
        var html = '<span class="price' + (match.compare_at_price > match.price ? ' price--on-sale' : '') + '">' +
          '<span class="price__current">' + money(match.price) + '</span>';
        if (match.compare_at_price > match.price) {
          html += '<s class="price__compare">' + money(match.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html + '</span>';
      }

      if (addBtn && addText) {
        addBtn.disabled = !match.available;
        addText.textContent = match.available ? 'Add to cart' : 'Sold out';
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    };

    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- Cart count refresh after quick-add ---------- */
  document.querySelectorAll('form.card__quick-add').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // If a previous ajax attempt failed we let the browser do a real POST.
      if (!window.fetch || form.dataset.fallback === 'true') return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (btn) btn.textContent = 'Added';
          setTimeout(function () {
            if (btn) { btn.textContent = original; btn.disabled = false; }
          }, 1600);
        })
        .catch(function () {
          // Fall back to a full-page form post so the add still lands.
          form.dataset.fallback = 'true';
          if (btn) { btn.textContent = original; btn.disabled = false; }
          form.submit();
        });
    });
  });
})();
